import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';
import { DrugDTO } from '@care-portals/api-interfaces';

import * as fromDrug from './drug.reducer';
import * as DrugSelectors from './drug.selectors';
import * as DrugActions from './drug.actions';

@Injectable()
export class DrugFacade {
  loading$ = this.store.pipe(select(DrugSelectors.getDrugLoading));
  saving$ = this.store.pipe(select(DrugSelectors.getDrugSaving));
  allDrug$ = this.store.pipe(select(DrugSelectors.getAllDrug));
  selectedDrug$ = this.store.pipe(select(DrugSelectors.getSelected));
  drugs$ = this.store.pipe(select(DrugSelectors.getDrugEntities));
  drugDetail$ = this.store.pipe(select(DrugSelectors.getDrugDetail));
  drugDetailLoading$ = this.store.pipe(select(DrugSelectors.getDrugDetailLoading));
  drugDetailError$ = this.store.pipe(select(DrugSelectors.getDrugDetailError));

  constructor(private store: Store<fromDrug.DrugPartialState>) { }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadDrugs(filters: any) {
    this.dispatch(DrugActions.loadDrugs({ filters }));
  }

  loadDrugByDin(din: string) {
    this.dispatch(DrugActions.loadDrugByDin({ din }));
  }

  clearDrugDetail() {
    this.dispatch(DrugActions.clearDrugDetail());
  }

  saveDrug(drug: DrugDTO) {
    this.dispatch(DrugActions.saveDrug({ drug }));
  }

  updateDrug(id: string, drug: DrugDTO) {
    this.dispatch(DrugActions.updateDrug({ id, drug }));
  }
}
